import { useCallback } from 'react'
import { HttpClientConfig, useHttpClientConfig } from '../../useHttpClientConfig'
import { useServiceCountryUrl } from '../useServiceCountryUrl'
import { Consultant } from './types'
import { makeGetConsultant } from './consultants'

interface ConsultantsService {
  getConsultant: (consultantGid: string) => Promise<Consultant>
  isReady: boolean
}

const useConsultantsService = (): ConsultantsService => {
  const { config } = useHttpClientConfig()
  const { url } = useServiceCountryUrl('consultant')

  const getConsultant = useCallback(makeGetConsultant(url.href, config as HttpClientConfig), [config, url.href])

  return {
    getConsultant,
    isReady: Boolean(config),
  }
}

export { useConsultantsService }
